import React from "react";
import { CheckCircle2 } from "lucide-react";

export const ReportPositioning = ({ strategy }) => {
  const pos = strategy.brand_positioning || {};
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
        <h3 className="font-semibold text-emerald-400 mb-2">Positioning Statement</h3>
        <p className="text-white text-lg leading-relaxed">{pos.positioning_statement || "N/A"}</p>
      </div>
      <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
        <h3 className="font-semibold text-white mb-2">Unique Value Proposition</h3>
        <p className="text-slate-300">{pos.unique_value_proposition || "N/A"}</p>
      </div>
      <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
        <h3 className="font-semibold text-white mb-2">Brand Promise</h3>
        <p className="text-slate-300">{pos.brand_promise || "N/A"}</p>
      </div>
      <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
        <h3 className="font-semibold text-white mb-2">Elevator Pitch</h3>
        <p className="text-slate-300">{pos.elevator_pitch || "N/A"}</p>
      </div>
      {pos.tagline_options && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Tagline Options</h3>
          <div className="space-y-2">
            {pos.tagline_options.map((tagline, i) => (
              <div key={`tagline-${tagline.slice(0, 20)}-${i}`} className="flex items-center gap-3 p-3 bg-slate-800/50 rounded-lg">
                <span className="w-6 h-6 bg-emerald-500/20 text-emerald-400 rounded-full flex items-center justify-center text-sm font-medium">
                  {i + 1}
                </span>
                <span className="text-slate-200 font-medium">&ldquo;{tagline}&rdquo;</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
